module.exports = __webpack_public_path__ + "abb19b8a1e68f517b3c8963f88a99552.png";